import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './HomeModal.css';

const HomeModal = ({ children }) => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  // Handle route changes
  useEffect(() => {
    if (location.pathname === '/') {
      const hasShown = sessionStorage.getItem('homeModalShown');
      if (!hasShown) {
        const timer = setTimeout(() => {
          setIsOpen(true);
          setShouldRender(true);
          document.body.style.overflow = 'hidden';
          sessionStorage.setItem('homeModalShown', 'true');
        }, 300);

        return () => {
          clearTimeout(timer);
          setIsOpen(false);
          document.body.style.overflow = 'auto';
        };
      }
      else {
        setIsOpen(false);
        document.body.style.overflow = 'auto';
      }
    } else {
      setIsOpen(false);
      document.body.style.overflow = 'auto';
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!isOpen) {
      document.body.style.overflow = 'auto';
    }
  }, [isOpen])

  // Handle animation end to unmount
  useEffect(() => {
    if (!isOpen) {
      const timeout = setTimeout(() => setShouldRender(false), 600);
      return () => clearTimeout(timeout);
    }
  }, [isOpen]);

  if (!shouldRender) return null;

  return (
    <div className={`home-modal-overlay ${isOpen ? 'fade-in' : 'fade-out'}`}>
      <div className={`home-modal-box ${isOpen ? 'slide-in' : 'slide-out'}`}>
        <button className="home-modal-close" onClick={() => setIsOpen(false)}>
          &times;
        </button>
        <div className="home-modal-content">
          {children ||
            <div>
              <img src='/assets/images/popup.jpeg' />
            </div>}
        </div>
      </div>
    </div>
  );
};

export default HomeModal;
